// src/pages/battle/components/GameOverScreen.jsx
import React from 'react';
import { Award, XCircle, ChevronLeft } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';
import { countCasualties } from '../Battlemap.utils';

const GameOverScreen = ({
  victory,
  activeMission,
  activeSquad,
  soldiers,
  turnCount,
  navigateToAfterAction,
  alertColor,
  primaryColor
}) => {
  return (
    <div className={`bg-gray-800 border-2 ${
      victory ? 'border-green-500' : getColorClasses(alertColor, 'border')
    } rounded-lg p-8 text-center`}>
      {victory ? (
        <Award className="text-green-400 mx-auto mb-4" size={64} />
      ) : (
        <XCircle className={`${getColorClasses(alertColor)} mx-auto mb-4`} size={64} />
      )}
      
      <h2 className={`text-3xl font-bold mb-2 ${
        victory ? 'text-green-400' : getColorClasses(alertColor)
      }`}>
        {victory ? 'MISSION SUCCESS' : 'MISSION FAILED'}
      </h2>
      
      <p className="text-gray-300 mb-6">
        {victory 
          ? 'All hostiles eliminated. Excellent work, Commander.' 
          : 'Mission objectives not met. Retreating to base.'}
      </p>
      
      <div className="bg-gray-900 rounded-lg p-4 mb-6">
        <div className="grid grid-cols-2 gap-4">
          {victory && (
            <>
              <div>
                <p className="text-xs text-gray-400 mb-1">FUNDS</p>
                <p className="text-2xl font-bold text-green-400">
                  ${activeMission.rewards?.funds || 0}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-1">INTEL</p>
                <p className={`text-2xl font-bold ${getColorClasses(primaryColor)}`}>
                  +{activeMission.rewards?.intel || 0}
                </p>
              </div>
            </>
          )}
          <div>
            <p className="text-xs text-gray-400 mb-1">CASUALTIES</p>
            <p className={`text-xl font-bold ${
              victory ? 'text-yellow-400' : getColorClasses(alertColor)
            }`}>
              {countCasualties(activeSquad, soldiers)}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-400 mb-1">TURNS</p>
            <p className="text-xl font-bold text-gray-300">{turnCount}</p>
          </div>
        </div>
      </div>
      
      <button
        onClick={navigateToAfterAction}
        className={`${getColorClasses(primaryColor, 'bgMain')} ${getColorClasses(primaryColor, 'bgHover')} px-8 py-3 rounded-lg font-bold text-lg transition-all flex items-center gap-2 mx-auto`}
      >
        <ChevronLeft size={24} />
        AFTER ACTION REPORT
      </button>
    </div>
  );
};

export default GameOverScreen;